import { AppModuleClient } from './app/app.module.client'
import { bootstrapClientApp } from '@glidecms/deliver-core-dev/app-bootstrap/bootstrap-client'
import { Notifier } from '@airbrake/browser'
import { Resizer } from './helpers/resizeIFrame'
import { hotModuleReload } from './components/common/utilities/hot-module-reload'

bootstrapClientApp(AppModuleClient)

window.addEventListener('load', () => new Resizer('iframe.js-iframe-resizer'))

if (process.env.AIR_BRAKE_ENABLED) {
  window.onerror = function(message, source, lineno, colno, error): void {
    const airbrake = new Notifier({
      projectId: Number(process.env.AIR_BRAKE_PROJECT_ID),
      projectKey: process.env.AIR_BRAKE_PROJECT_KEY,
      environment: process.env.NR_ENV || 'local',
    })

    airbrake.notify({
      message,
      source,
      lineno,
      colno,
      error,
    })
  }
}

hotModuleReload()
